import type {
  ConnectButtonVariant} from '@shared/common/components/Buttons/ConnectButton';
import {
  ConnectButton
} from '@shared/common/components/Buttons/ConnectButton';
import { useAuth } from '@shared/common/providers/AuthProvider';
import { useManageSolanaWallet } from '@shared/helpers/web3/hooks/useManageSolanaWallet';

import type { WalletConnectType} from '../model/walletsConfig';
import { WALLETS_CONFIG } from '../model/walletsConfig';

type Props = {
  className?: string;
  connectType: WalletConnectType;
  variant: ConnectButtonVariant;
};

export const ConnectSolanaWalletButton = ({ className, connectType, variant }: Props) => {
  const { user, isAuth } = useAuth();

  const { handleConnectButtonClick, isConnectingSolanaWallet } = useManageSolanaWallet({
    isAuth,
    user,
  });
  const { connectButtonText } = WALLETS_CONFIG[connectType];

  return (
    <ConnectButton
      className={className}
      onClick={handleConnectButtonClick}
      disabled={isConnectingSolanaWallet}
      variant={variant}
    >
      {connectButtonText}
    </ConnectButton>
  );
};
